import Image from 'next/image';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';

import { customLoader } from '../../utils/customLoaderImage';

import style from './opcoes.module.scss';

const parse = require('html-react-parser');

export default function Opcoes({ dados }) {
  const options = {
    settings: {
      overlayColor: 'rgba(25,136,124,0.71)',
      autoplaySpeed: 1500,
      transitionSpeed: 900,
      showDownloadButton: false,
    },

    caption: {
      captionColor: '#a6cfa5',
      captionFontFamily: 'Raleway, sans-serif',
      captionFontWeight: '300',
      captionTextTransform: 'uppercase',
    },
  };

  if (!dados) return null;

  const { titulo, subtitulo, fotos } = dados;

  return (
    <div className={style.section}>
      <h2>{parse(titulo)}</h2>
      <h3>{parse(subtitulo)}</h3>

      <div>
        <SimpleReactLightbox>
          <SRLWrapper options={options}>
            <div className={style.containerImage}>
              {fotos.map((foto) => (
                <a
                  className={style.image}
                  href={foto.imagem.url}
                  tabIndex={-1}
                  key={foto.imagem.url}>
                  <figure>
                    <Image
                      alt='Imagem Ilustrativa Plug Apê'
                      objectFit='cover'
                      src={foto.imagem.url}
                      loader={customLoader}
                      width='900'
                      height='1200'
                    />
                    <figcaption>Imagem Ilustrativa Plug Apê</figcaption>
                  </figure>
                </a>
              ))}
            </div>
          </SRLWrapper>
        </SimpleReactLightbox>
      </div>
    </div>
  );
}
